import React from 'react';
import { Navigate } from "react-router-dom";

// This page is kept for backwards compatibility but logout is now handled in AppMenu
// If someone navigates directly to /logout, redirect them to auth page
export const LogoutPage: React.FC = () => {
    return <Navigate to="/auth" replace />;
};
